import React from "react";
import { Navigate, useParams } from "react-router-dom";
import Layout from "../../components/core/Layout";
import { BrandList } from "../../components/MainPage/BrandList";
import Dashboard from "../../components/MainPage/Dashboard";

const MainPage = () => {
  const { page } = useParams();
  const [currentPage, setCurrentPage] = React.useState<"dashboard" | "brandlist">("dashboard");

  
  React.useEffect(() => {
    setCurrentPage(page === "dashboard" ? "dashboard" : "brandlist");
  },[page])


  return( page === "dashboard" || page === "brandlist" ?
    <Layout withBreadcrumbs={false}>
      {currentPage === "dashboard" ? <Dashboard /> : <BrandList/>}
    </Layout> :
    <Navigate to="/dashboard" />
  )
}

export default MainPage;